import { IDGSEnvironment } from '@dotgov/z_core';

export class BuilderEnvironment {
  static API() {
    return 'http://moldova.api/';
  }

  static CONFIG(): IDGSEnvironment {
    return {
      apiUrl: BuilderEnvironment.API(),
      debug: true,
      formBuilder: true,
    };
  }
}
